const AVG_WORD_LENGTH = 5;

export const calculateRawWPM = (test) => {
  return ((test.totalSelections / AVG_WORD_LENGTH) / (test.duration / 60000));
}

export const calculateCorrectWPM = (test) => {
  return ((test.targetTextLength - test.minStringDistance) / AVG_WORD_LENGTH) / (test.duration / 60000);
}

//Return Infinity when sentence has no duration, so parent DisplayTypingResults can deal
export const calculateAccuracy = (test) => {
  return (
    (test.duration > 0) ?
      ((test.targetTextLength - test.minStringDistance) / test.targetTextLength) * 100
      : Infinity
  );
}

export const calculateAverageDuration = (tests) => {
  var totalTimer = 0;
  var validTests = 0;
  tests.forEach((test) =>{
    if( test.duration > 0){
      totalTimer += test.duration;
      ++validTests;
    }
  });
  return validTests > 0 ?  totalTimer / validTests : 0;
}

export const calculateAverageWPM = (tests) => {
  var totalWPM = 0;
  var validTests = 0;
  tests.forEach((test) =>{
     let testWPM = calculateRawWPM(test);
     if(!isNaN(testWPM) && Number.isFinite(testWPM)){
      totalWPM += testWPM;
      ++validTests;
     }
  });
  return validTests > 0 ? totalWPM / validTests : 0;
}

export const calculateAverageCorrectWPM = (tests) => {
  var totalWPM = 0;
  var validTests = 0;
  tests.forEach((test) =>{
    let testWPM = calculateCorrectWPM(test);
    if(!isNaN(testWPM) && Number.isFinite(testWPM)){
      totalWPM += testWPM;
      ++validTests;
     }
  });
  return validTests > 0 ? totalWPM / validTests : 0;
}

export const calculateAverageAccuracy = (tests) => {
  var totalMSD = 0;
  var validTests = 0;
  tests.forEach((test) =>{
    let testMSD = calculateAccuracy(test);
    if((test.duration > 0) && !isNaN(testMSD) && Number.isFinite(testMSD)){
      totalMSD += testMSD;
      ++validTests;
    }
  });
  return validTests > 0 ?  totalMSD / validTests : 0;
}

export const calculateMinimumStringDistance = (str1, str2, ignoreCase) => {
    const m = str1.length;
    const n = str2.length;

    const string1 = ignoreCase ? str1.toUpperCase() : str1;
    const string2 = ignoreCase ? str2.toUpperCase() : str2;

    const dp = Array.from({ length: m + 1 }, () => Array(n + 1).fill(0));

    for (let i = 0; i <= m; i++) {
        for (let j = 0; j <= n; j++) {
        if (i === 0) {
            dp[i][j] = j;
        } else if (j === 0) {
            dp[i][j] = i;
        } else if (string1[i - 1] === string2[j - 1]) {
            dp[i][j] = dp[i - 1][j - 1];
        } else {
            dp[i][j] = 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
        }
        }
    }
    const msd = dp[m][n];
    return msd;
}

